var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-content"},[(_vm.st==52)?_c('water52',{ref:"water"}):_c('water',{ref:"water"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }